// convert laptime string to miliseconds
export const laptime2ms = time =>
{
  // split the string
  let [ a, ms ] = time.split( '.' ),
      [ m, s ] = a.split( ':' )
  
  // make sure all values are integers & return the combined result
  return parseInt( '0' + ms ) + parseInt( '0' + s ) * 1000 + parseInt( '0' + m ) * 60 * 1000
}

// convert miliseconds to laptime string
export const ms2laptime = time =>
{
  const m = String( '0' + parseInt( time / 60000 ) ).substr( -1 ),
        s = String( '00' + parseInt( time / 1000 ) % 60).substr( -2 ),
        ms = String( '000' + time ).substr( -3 )
  return m + ':' + s + '.' + ms
}

// convert miliseconds to time difference in seconds.miliseconds
export const ms2diff = time =>
{
  // return empty when zero or invalid
  if ( !time ) return ''
  // get abs time, seconds and milliseconds
  const a = Math.abs( time ),
        s = parseInt( a / 1000 ) % 60,
        ms = String( '000' + a ).substr( -3 )
  // return the string
  return ( time > 0 ? '+' : '-' ) + s + '.' + ms
}

/**
 * Format a date like 2026-10-03 as 3 Oct 2026, or with the month in full as 3 October 2026
 * @param {string} date date as YYYY-MM-DD
 * @param {boolean} fullMonth whether to write the month in full
 * @returns {string} readable date, the input when it is not a date
 */
export const formatDate = ( date, fullMonth = false ) =>
{
  const parsed = new Date( date + 'T12:00:00' )
  if ( !date || isNaN( parsed ) ) return date || ''
  return parsed.toLocaleDateString( 'en-GB', { day: 'numeric', month: fullMonth ? 'long' : 'short', year: 'numeric' } )
}

// add minutes to a time string
export const addMinutes = (time, minsToAdd ) => 
  {
    function D(J){ return (J<10? '0':'') + J;};
    var piece = time.split(':');
    var mins = piece[0]*60 + +piece[1] + +minsToAdd;  
    return D(mins%(24*60)/60 | 0) + ':' + D(mins%60);  
  }  
/**
 * Steps between time labels on a chart axis in seconds, from fine to coarse
 * @type {Array<number>}
 */
const CLOCK_STEPS = [ 60, 120, 300, 600, 900, 1800, 3600, 7200 ]

/**
 * Get labels for a chart axis of seconds since midnight, at a round step such as every 15 minutes
 * @param {number} min first shown value
 * @param {number} max last shown value
 * @param {number} most most labels to show
 * @returns {Array<{ v: number, f: string }>} ticks with value and time like 14:15
 */
export const getClockTicks = ( min, max, most = 8 ) =>
{
  const step = CLOCK_STEPS.find( s => ( max - min ) / s <= most ) || CLOCK_STEPS[ CLOCK_STEPS.length - 1 ]
  const ticks = []

  for ( let v = Math.ceil( min / step ) * step; v <= max; v += step )
  {
    ticks.push( { v, f: seconds2clock( v ) } )
  }

  return ticks
}

/**
 * Convert a time of day like 14:05:30 to seconds since midnight
 * @param {string} time time as HH:MM:SS
 * @returns {number} seconds since midnight, 0 when it is not a time
 */
export const time2seconds = time =>
{
  const [ h = 0, m = 0, s = 0 ] = String( time || '' ).split( ':' ).map( part => parseInt( part ) || 0 )
  return h * 3600 + m * 60 + s
}

/**
 * Convert seconds since midnight to a time of day like 14:05
 * @param {number} seconds seconds since midnight
 * @returns {string} time as HH:MM
 */
export const seconds2clock = seconds =>
{
  const minutes = Math.floor( seconds / 60 )
  return String( Math.floor( minutes / 60 ) % 24 ).padStart( 2, '0' ) + ':' + String( minutes % 60 ).padStart( 2, '0' )
}
